import { configureStore } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';
import layout from '../containers/Layout/slice';
import toaster from '../components/Toaster/slice';
import hardResetModal from '../components/modals/HardResetModal/slice';
import deleteAccountModal from '../components/modals/DeleteAccountModal/slice';
import deleteVehicleModal from '../components/modals/DeleteVehicleModal/slice';
import createVehicleModal from '../components/modals/CreateVehicleModal/slice';
import createAccountModal from '../components/modals/CreateAccountModal/slice';
import createRfidModal from '../components/modals/CreateRfidModal/slice';
import exportModal from '../components/modals/ExportModal/slice';
import appReducer from '../appSlice';

const store = configureStore({
    reducer: {
        app: appReducer,
        hardResetModal,
        deleteAccountModal,
        deleteVehicleModal,
        createVehicleModal,
        createRfidModal,
        createAccountModal,
        exportModal,
        layout,
        toaster,
    },
});

export default store;

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
